import axios from "axios";
import { COMMAND_TYPES, COMMAND_ENDPOINTS } from "../constants/commandTypes";
import { normalizeCommand } from "../utils/helpers";

const evControlApi = axios.create({
    baseURL: `${import.meta.env.VITE_API_URL}`,
    timeout: 10000
});

export const sendCommand = async (commandType, payload) => {
    // Validate command type using COMMAND_TYPES (remove this if not needed)
    if (!Object.values(COMMAND_TYPES).includes(commandType)) {
        throw new Error(`Invalid command type: ${commandType}`);
    }

    const commandKey = normalizeCommand(commandType);
    const endpoint = COMMAND_ENDPOINTS[commandKey];

    console.log(commandKey)

    if (!endpoint) {
        throw new Error(`Unknown command type: ${commandKey}`);
    }

    console.log(endpoint);
    console.log(payload);

    try {
        const response = await evControlApi.post(endpoint, payload);
        return response.data;
    } catch (error) {
        // Normalize Axios error for clearer upstream handling
        const status = error?.response?.status;
        const data = error?.response?.data;
        const message = status
            ? `API error ${status} when sending ${commandType}`
            : `Network/Client error when sending ${commandType}: ${error.message}`;

        console.error(message, data || error);

        const normalized = new Error(message);
        if (status) normalized.status = status;
        if (data) normalized.data = data;
        throw normalized;
    }
};